export const RouteEditedHandler = (routeId: string | number) => {
  let previouslyOpenedRoute = localStorage.getItem("previouslyOpenedRoute");
  if (previouslyOpenedRoute && previouslyOpenedRoute !== "") {
    localStorage.setItem("recentlyOpenedRoute", `${previouslyOpenedRoute}`);
  }
  localStorage.setItem("recentlyChangedRoute", `${routeId}`);
};
